import React, {useEffect, useState} from "react";
import { config } from "../config/config";
import GradoForm from "../components/GradoForm";
import GradoList from "../components/GradoList";
import showAlert from "../components/Alert";
import showConfirm from "../components/ConfirmAlert";

const Grados = () => {
    const [editingGrado, setEditingGrado] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);
    const [maestros, setMaestros] = useState([]);


    const reloadGradoList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    const handleCreateOrUpdate = (grado) => {
        const url = editingGrado
            ? `${config.apiUrl}/grados/${editingGrado.grado_id}`
            : `${config.apiUrl}/grados`;
        const method = editingGrado ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(grado),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error al guardar la información");
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingGrado);
                setEditingGrado(null);
                setResetForm(true);
                reloadGradoList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/grados/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Grado eliminado");
                    reloadGradoList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    const fetchMaestros = () => {
        fetch(`${config.apiUrl}/usuarios/maestros`)
            .then((res) => res.json())
            .then((data) => {
                console.log("Maestros:", data);
                setMaestros(data);
            })
            .catch((error) => console.error("Error al obtener maestros:", error));
    };

    useEffect(() => {
        fetchMaestros();
    }, []);

    return (
        <div>
            <GradoForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingGrado}
                resetForm={resetForm}
                maestros={maestros} // Pasa la lista de maestros aquí (puedes obtenerla de la API)
            />
            <GradoList
                onEdit={(grado) => setEditingGrado(grado)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger} // Pasamos reloadTrigger a GradoList
            />
        </div>
    );
};

export default Grados;